import { useEffect } from 'react'
import { refreshGoogleTranslateWhenReady } from '@/lib/utils/googleTranslate'

/** Re-run Google Translate when in-page content changes (e.g. application detail tabs). */
export function useGoogleTranslateRefresh(...deps: ReadonlyArray<unknown>): void {
  useEffect(() => {
    refreshGoogleTranslateWhenReady()
    // Intentionally driven by caller-supplied deps (tab id, edit mode, etc.)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps)
}
